export default __webpack_public_path__ + "static/media/app-store-disabled.4080e424.svg";